import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';

import { Cloudinary } from 'services/cloudinary';
import { XmStore, XmStoreUtil } from 'services/store';
import { AccountSummary, SummaryLineWithPlan } from 'store/account-summary/models';
import { CmsPlanSwitch } from 'store/cms/models';

@Component({
    selector: 'plan-switch-ineligible-overage',
    styleUrls: ['./ineligible-overage.scss'],
    templateUrl: './ineligible-overage.html',
    standalone: false
})
export class PlanSwitchIneligibleOverageComponent implements OnInit {

    public pageData: CmsIneligibleOveragePlanData;
    public overageIcon: MediaImageOptions;
    public description: string;

    private xmStore: XmStore;
    private state: StateService;
    private subscriptions: Subscription[] = [];

    constructor(state: StateService, xmStore: XmStore) {
        Object.assign(this, { state, xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsPlanSwitch>(CmsPlanSwitch), (result: CmsPlanSwitch) => {
            this.pageData = result.ineligibleOveragePlanData;

            this.overageIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.overageIcon)
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (accountSummary: AccountSummary) => {
            const lineByKey: SummaryLineWithPlan = accountSummary.getLineSummaryWithPlanByKey(this.state.params.line_id);
            this.description = this.pageData.description.replace('[NICKNAME]', lineByKey.line.displayName);
        }));
    }
}
